import { SEOHead } from "@components/organisms";
import { InnerPageLayout } from "@components/templates";
import { Text } from "@components/atoms";

/**
 * About page ("Nosotros").
 * Uses the same layout as profile. Displays a description text.
 */
export function AboutPage() {
  return (
    <>
      <SEOHead title="Nosotros" />
      <InnerPageLayout title="Nosotros">
        <div className="px-4 sm:pl-8 max-w-3xl">
          <Text
            variant="body"
            as="p"
            className="text-black leading-relaxed whitespace-pre-line"
          >
            Ticketin es una plataforma digital que simplifica la gestión y venta de entradas para eventos. Conectamos organizadores y asistentes a través de una solución ágil, segura y fácil de usar, que permite crear eventos, vender tickets en línea y controlar el acceso de manera eficiente. Nuestro objetivo es facilitar la organización de experiencias exitosas, optimizando procesos y mejorando la experiencia del usuario en cada etapa del evento.
          </Text>
        </div>
      </InnerPageLayout>
    </>
  );
}
